(function() {
  'use strict';

  function AuditLogsController($scope, Users) {
    var ctrl = this;

    ctrl.expanded = typeof $scope.expanded !== 'undefined' ? $scope.expanded : false;
    ctrl.showHeader = typeof $scope.showHeader !== 'undefined' ? $scope.showHeader : true;
    ctrl.dates = [];
    ctrl.loading = true;

    if ($scope.userId) {
      Users.getAuditLog($scope.userId)
        .then(function(result) {
          ctrl.dates = result;
          $scope.profileDates = result;
        })
        .finally(function() {
          ctrl.loading = false;
        });
    } else {
      ctrl.dates = $scope.profileDates || [];
      ctrl.loading = false;
    }
  }

  AuditLogsController.$inject = ['$scope', 'UsersService'];

  function audtiLogsDirective() {
    return {
      scope: {
        userId: '=?',
        profileDates: '=?',
        expanded: '=?',
        limit: '=?',
        showHeader: '=?',
        perPage: '=?'
      },
      restrict: 'AE',
      templateUrl: 'app/components/users/directives/auditLogs.html',
      replace: true,
      controller: AuditLogsController,
      controllerAs: 'ctrl',
      link: function(scope) {
        scope.options = {};
        scope.perPage = scope.perPage || 0;
      }
    };
  }

  angular.module('component.users')
    .directive('auditLogs', audtiLogsDirective)
    .controller('AuditLogsController', AuditLogsController);
})();
